module.exports = MonacoEditor;